import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ConfirmDialog from 'common/components/modal/confirmation_dialog';
import { deleteAccount } from 'common/ducks/payout';

const mapStateToProps = (state, { account }) => {
  return {
    dialogVisible: !!account,
    dialogHeader: account? `Delete ${account.system} account?` : '',
    dialogMessage: account? `Are you sure you want to delete your ${account.system == 'paypal'? 'PayPal' : 'Payoneer'} account?` : ''
  };
}

const mapDispatchToProps = (dispatch, { account, onSuccess, onToggle }) => {
  const actions = bindActionCreators({
    submitAction: (e) => {
      e.preventDefault();
      e.stopPropagation();
      return deleteAccount(account, onSuccess);
    }
  }, dispatch);

  return {
    ...actions,
    toggleDialog: onToggle
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);



// WEBPACK FOOTER //
// ./account/containers/payout/delete_acc_modal.js